import "./index.css";
import "url-search-params-polyfill";
import "@emotion/react";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initGA4 } from "./utils/analytics";

initGA4();

const isProduction = import.meta.env.VITE_ENVIRONMENT === "production";

if (isProduction) {
  // Google Tag Manager
  const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
  if (gtmId) {
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(gtmScript);
  }

  // Qualtrics
  const qualtricsId = import.meta.env.VITE_QUALTRICS_ID;
  const qualtricsIdLower = import.meta.env.VITE_QUALTRICS_ID_LOWERCASE;
  if (qualtricsId && qualtricsIdLower) {
    const qualtricsDiv = document.createElement("div");
    qualtricsDiv.id = qualtricsId;
    document.body.appendChild(qualtricsDiv);
    const qualtricsScript = document.createElement("script");
    qualtricsScript.innerHTML = `
      (function(){var g=function(e,h,f,g){
        this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){
        for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);
        if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
        this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048e5);
        b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
        this.check=function(){var a=this.get(f);if(a)a=a.split(":");
        else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));
        else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case"v":return!1;
        case"r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
        this.go=function(){if(this.check()){var a=document.createElement("script");
        a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
        this.start=function(){var t=this;"complete"!==document.readyState?
        window.addEventListener?window.addEventListener("load",function(){t.go()},!1):
        window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
        try{new g(100,"r","QSI_S_${qualtricsId}",
        "https://${qualtricsIdLower}-healthinherhue.siteintercept.qualtrics.com/SIE/?Q_ZID=${qualtricsId}").start()}
        catch(i){}})();
    `;
    document.head.appendChild(qualtricsScript);
  }

  // HubSpot
  const hubspotPortalId = import.meta.env.VITE_HUBSPOT_PORTAL_ID;
  if (hubspotPortalId) {
    const hubspotScript = document.createElement("script");
    hubspotScript.type = "text/javascript";
    hubspotScript.id = "hs-script-loader";
    hubspotScript.async = true;
    hubspotScript.defer = true;
    hubspotScript.src = `//js.hs-scripts.com/${hubspotPortalId}.js`;
    document.head.appendChild(hubspotScript);
  }

  // OTTO SEO
  const ottoUuid = import.meta.env.VITE_OTTO_SEO_DATA_UUID;
  if (ottoUuid) {
    const ottoScript = document.createElement("script");
    ottoScript.type = "text/javascript";
    ottoScript.id = "otto-seo-dynamic-optimization";
    ottoScript.setAttribute("data-uuid", ottoUuid);
    ottoScript.src = "https://dashboard.linkgraph.com/scripts/dynamic_optimization.js";
    document.head.appendChild(ottoScript);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
